import {
  ICreateUserRequestBody,
  IEditUserRequestBody,
  IUserManagementObject,
} from '../../models/UserManagementModel';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { storage, STORAGE_CONSTANTS } from '../LocalStorage';
import { ServerType, ServiceType } from '../ServiceType.data';

const serviceType = ServiceType.None;

export class UserService {
  private readonly service: ApiServiceBase = new ApiService(serviceType, ServerType.tangra);

  private readonly dcaBackendService: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.dcaBackend,
  );

  public createUser(data: ICreateUserRequestBody): Promise<string> | string {
    return this.dcaBackendService.post({ route: [API_ROUTE.UPDATE_USER] }, data);
  }
  public getUser(): Promise<IUserManagementObject> | IUserManagementObject {
    const userid = storage.getItem(STORAGE_CONSTANTS.userId);
    return this.dcaBackendService.get({ route: [API_ROUTE.GET_USERS], query: { userid } });
  }
  public updateUser(data: IEditUserRequestBody): Promise<string> | string {
    return this.dcaBackendService.patch(
      { route: [API_ROUTE.UPDATE_USER] },
      { ...data, UserId: data.userId },
    );
  }
}

const userManagementService = new UserService();
export default userManagementService;
